export default function snsLinkShare() {
  //シェアするURL (現在のページのURL)
  let shareUrl = window.location.href;

  //ページの概要 (現在のページのタイトル)
  let description = document.title;

  //ロード時に、各SNSボタンのURLを設定します
  let params = [shareUrl, description];
  setUrl("facebook", "https://www.facebook.com/sharer/sharer.php?u={0}&t={1}", params);
  setUrl("twitter", "https://twitter.com/share?url={0}&text={1}", params);
  setUrl("hatebu", "http://b.hatena.ne.jp/entry/{0}", params);
  setUrl("line", "https://social-plugins.line.me/lineit/share?url={0}", params);
}

//リンクにURLを設定する
function setUrl(type, url, params) {
  let element = document.querySelector(".sns-button ." + type + " a");
  if (element) {
    element.href = url.replace(/(\{[0-9]+\})/g, function (all, g1, p, s) {
      return encodeURIComponent(params[ parseInt(g1.substr(1, g1.length - 2), 10) ]);
    });
    element.addEventListener("click", function(e) { return openShare(e, type, element) });
  }
}

//SNSボタンがクリックされたら、各SNSのシェア画面を開く
function openShare(e, type, element) {
  let shareUrl = element.href;
  let w = parseInt(element.getAttribute("data-dialog-w"), 10);
  window.open(shareUrl, type + "_win", 'width=' + w + ', height=600, personalbar=0, toolbar=0, scrollbars=1');
  e.preventDefault();
  return false;
}
